/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { NumberBox } from './NumberBox';
import { KeyUpEvent } from 'devextreme/ui/number_box';

interface MoneyBoxProps {
    id?: string;
    dataTestid?: string;
    value?: number;
    allowNegative?: boolean;
    displayChange?: boolean;
    format?: string;
    readOnly?: boolean;
    disabled?: boolean;
    label?: string;
    helperText?: React.ReactNode;
    required?: boolean;
    children?: React.ReactNode;
    validator?: React.ReactNode;
    width?: string;
    max?: number;
    mask?: string;
    maskInvalidMessage?: string;
    onChange: (value: number) => void;
    onEnterKey?: () => void;
    onKeyUp?: ((e: KeyUpEvent) => void) | undefined;
    validateValue?: (value: string) => boolean;
    onValidationEvent?: (isValid: boolean) => void;
    validateValueMessage?: string;
}

export const MoneyBox: React.FC<MoneyBoxProps> = ({
    id,
    dataTestid,
    value,
    allowNegative = false,
    displayChange = false,
    format = '$ #,##0',
    mask,
    maskInvalidMessage,
    readOnly = false,
    disabled = false,
    label,
    helperText,
    required = false,
    children,
    validator,
    width = 'auto',
    max,
    onChange,
    onEnterKey,
    validateValue,
    onValidationEvent,
    validateValueMessage,
}) => {
    return (
        <NumberBox
            id={id}
            label={label}
            helperText={helperText}
            allowNegative={allowNegative}
            data-testid={dataTestid}
            format={displayChange ? '$ #,##0.00' : format}
            mask={mask}
            maskInvalidMessage={maskInvalidMessage}
            value={value}
            disabled={disabled}
            required={required}
            onChange={onChange}
            readOnly={readOnly}
            width={width}
            max={max}
            onEnterKey={onEnterKey}
            validateValue={validateValue}
            validateValueMessage={validateValueMessage}
            validator={validator}
            onValidationEvent={onValidationEvent}
        >
            {children}
        </NumberBox>
    );
};
